import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import RangeFilterModal from '../RangeFilterModal/RangeFilterModal';
import SelectFilterModal from '../SelectFilterModal/SelectFilterModal';

function FilterSelect({ options, addFilter, activeFilters }) {
  const [openRangeFilterModal, setOpenRangeFilterModal] = useState(false);
  const [openSelectFilterModal, setOpenSelectFilterModal] = useState(false);
  const [currentFilter, setCurrentFilter] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const isFilterActive = (filter) => {
    return activeFilters.some(f => f.name === filter);
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNewFilter = (filter) => {
    if (filter.type === "range") {
      setCurrentFilter(filter);
      setOpenRangeFilterModal(true);
    } else if (filter.type === "select") {
      setCurrentFilter(filter);
      setOpenSelectFilterModal(true);
    }
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="add-filter-button"
        aria-controls={open ? 'add-filter-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<IoIosArrowDown />}
      >
        Ajouter un filtre
      </Button>
      <Menu
        id="add-filter-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {Object.entries(options).map(([key, option]) => (
          <MenuItem key={key} disabled={isFilterActive(option.name)} onClick={() => handleNewFilter(option)} disableRipple>
            Filtrer par {option.name}
          </MenuItem>
        ))}
      </Menu>
      <RangeFilterModal selectedFilter={currentFilter} openModal={openRangeFilterModal} setOpenModal={setOpenRangeFilterModal} addRangeFilter={addFilter} />
      <SelectFilterModal selectedFilter={currentFilter} openModal={openSelectFilterModal} setOpenModal={setOpenSelectFilterModal} addSelectFilter={addFilter} />
    </div>
  )
}

export default FilterSelect;